import React from 'react'
import { useIntl } from 'react-intl'
import Icons from '@atoms/Icons/Icons'

export const CheckoutUSP = () => {
  const { formatMessage } = useIntl()

  return (
    <ul>
      <li>
        <Icons iconName='Check' width='28px' height='28px' />
        <span className='text-15'>
          {formatMessage({
            defaultMessage: 'Toll-free service hotline',
            id: 'msp.footercheckout.usp.1'
          })}
        </span>
      </li>
      <li>
        <Icons iconName='Check' width='28px' height='28px' />
        <span className='text-15'>
          {formatMessage({
            defaultMessage: 'Fast delivery',
            id: 'msp.footercheckout.usp.2'
          })}
        </span>
      </li>
      <li>
        <Icons iconName='Check' width='28px' height='28px' />
        <span className='text-15'>
          {formatMessage({
            defaultMessage: 'Free return shipment',
            id: 'msp.footercheckout.usp.3'
          })}
        </span>
      </li>
    </ul>
  )
}

export const FooterPaymentIcons = () => (
  <ul className='mb-8 mt-2 flex flex-row items-center justify-center md:mb-0 md:mt-12 md:justify-start'>
    <li className='mr-2'>
      <Icons iconName='PayPal' color='#FFFFFF' height='28px' width='34px' />
    </li>
    <li className='mr-2'>
      <Icons iconName='MasterCard' height='28px' width='34px' color='#FFFFFF' />
    </li>
    <li className='mr-2'>
      <Icons iconName='VisaCard' height='28px' width='34px' color='#FFFFFF' />
    </li>
    <li className='mr-2'>
      <Icons iconName='DebitCard' height='28px' width='34px' color='#FFFFFF' />
    </li>
    <li>
      <Icons
        iconName='InvoiceWhite'
        height='28px'
        width='34px'
        color='#FFFFFF'
      />
    </li>
  </ul>
)

export const FooterShippingMethods = () => (
  <div className='mb-8 mt-5 flex w-full flex-row justify-center md:mb-3 md:justify-start'>
    <div className='flex flex-col gap-2 pr-3'>
      <Icons iconName='DHL' height='13px' width='59px' />
    </div>
    <div className='flex flex-col gap-2'>
      <Icons iconName='DHLExpress' height='19px' width='59px' />
    </div>
  </div>
)
